<app-i18n-dictionary>
    <span [attr.transid]="deleteQuoteMessageTextId" i18n="@@quote-detail_delete-quote-confirmation-message">Do you
        really want to delete this quote?
    </span>
    <span [attr.transid]="deleteQuoteProductMessageTextId"
          i18n="@@quote-detail_delete-quote-product-confirmation-message">Do you really want to delete this product from
        the quote?
    </span>
</app-i18n-dictionary>

<div class="loading-spinner" *ngIf="isPending">
    <div class="background"></div>
    <mat-spinner [diameter]="70"></mat-spinner>
</div>

<div class="menu-container" *ngIf="!(editQuote$ | async)">
    <div class="menu-header">
        <div class="back-arrow">
            <button class="dotted-arrow" mat-icon-button (click)="onDeselectQuote()">←</button>

        </div>
        <h3 class="quote-name">{{quoteName}}</h3>
    </div>

    <div class="meta-btn-wrapper">
        <button class="btn-primary main-btn" [disabled]="isPending" (click)="editQuote()"
                i18n="@@quote-detail_edit-button">Edit
        </button>
        <button (click)="openDeleteConfirmationDialog($event)" [disabled]="isPending"
                class="btn-primary main-btn" i18n="@@quote-detail_delete-button">Delete
        </button>
    </div>

    <div class="quote-created-on">
        <span i18n="@@quote-detail_created-on">Created on: </span> {{quoteBarItem.quote.creationDate | date}}
    </div>

    <div class="quote-created-quote-message-container">
        <div class="created-quote-message">
            <p i18n="@@create-new-quote-landing_great-job">Great job!</p>
            <p i18n="@@create-new-quote-landing_welcome-message">Now you can start selecting your favourite Hering products by simply clicking 'Add to Quote'.</p>
        </div>
    </div>


    <div class="menu-footer">
        <div class="quote-action-buttons">
            <button class="btn-primary main-btn start-shopping-btn" [disabled]="isPending"
                    (click)="onCloseMenu()" i18n="@@create-new-quote-landing_start-shopping-button">Start shopping
            </button>
        </div>
    </div>
</div>


<edit-quote *ngIf="(editQuote$ | async)" [selectedQuote]="quote"></edit-quote>
